import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46309660&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/Notifications/Notification.vue').default})
